<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "LocationIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
